import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { initializeFirestore, persistentLocalCache, collection, query, where, onSnapshot, addDoc, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { getMessaging, onMessage } from 'firebase/messaging';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
    apiKey: "AIzaSyCbn_iHwuf8NMz05dx6l1ghFi8tKOXqssA",
    authDomain: "grocerybuilder-9c054.firebaseapp.com",
    projectId: "grocerybuilder-9c054",
    storageBucket: "grocerybuilder-9c054.appspot.com",
    messagingSenderId: "131558569004",
    appId: "1:131558569004:web:df10cce129654aaf484d89",
    measurementId: "G-4CBS7QVVCB",
    vapidKey: 'BM5Ht-VXFMzmMSrJ0b0gSg1PEnnOSBNaljG5cxVYAS_6IEvkOPkTSaxWXVgLMat9Uk5bBaaqHk-t37Gyt-YB6y4'
  };


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore with persistent local cache (IndexedDB) for offline support
const firestore = initializeFirestore(app, {
  localCache: persistentLocalCache({}),
});

const storage = getStorage(app);

// Capacitor iOS/Android: getAuth() + setPersistence can hang forever.
// initializeAuth + indexedDBLocalPersistence is the supported native pattern.
function createAuth() {
  if (Capacitor.isNativePlatform()) {
    try {
      return initializeAuth(app, { persistence: indexedDBLocalPersistence });
    } catch (err) {
      // Already initialized (hot reload / re-import)
      return getAuth(app);
    }
  }
  return getAuth(app);
}
const auth = createAuth();

// FCM web APIs are unavailable in iOS WKWebView / Capacitor — guard so the app still boots.
let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn('Firebase Messaging unavailable in this environment:', err?.message || err);
}
const functions = getFunctions(app, 'us-central1');
const vapidKey = firebaseConfig.vapidKey;

// Opt-in only — default local dev uses deployed Cloud Functions (needed for Stripe checkout).
if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === 'true') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}


// Export auth and firestore functions and constants
export { firestore, collection, auth, query, where, onSnapshot, addDoc, deleteDoc, updateDoc, doc, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, sendEmailVerification, sendPasswordResetEmail, storage, getStorage, messaging, onMessage, vapidKey, firebaseConfig, functions };
